import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
import DialogList from 'src/dialogs';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { AnyObject } from 'final-form';

type SummaryOption = {
    id: number,
    summaryOption: string
};

interface IGenerateExcelSummaryDialogProps {
    dialogName: string;
    handleSubmit?: (payload: AnyObject) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
    summaryOptions?: Array<SummaryOption>;
}

const GenerateExcelSummaryDialog = (props: IGenerateExcelSummaryDialogProps) => {
    const [summaryOptions, setSummaryOptions] = useState<Array<SummaryOption>>(undefined);
    const { register, handleSubmit } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (!!props?.summaryOptions) {
            setSummaryOptions(props?.summaryOptions);
        }
    }, [props?.summaryOptions]);

    const onCreate = () => {
        console.log('ReportOptionsDialog onCreate()');
    };

    const onSubmit = (data: AnyObject) => {
        const formData = data.generateSummary;
        if (formData) {
            props.handleSubmit(formData);
        }
    };

    return (
        <Dialog title="Generate Excel Summary" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '20%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                            <RHFInputBox
                                type={'date'}
                                label={'Begin Date:'}
                                name={'generateSummary.begDate'}
                                register={register}
                            />
                            <RHFInputBox
                                type={'date'}
                                label={'End Date:'}
                                name={'generateSummary.endDate'}
                                register={register}
                            />
                        </div>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                            <RHFInputBox
                                label={'Client #:'}
                                name={'generateSummary.clientNumber'}
                                register={register}
                            />
                            <RHFInputBox
                                label={'Client Landman #:'}
                                name={'generateSummary.clientLandmanNumber'}
                                register={register}
                            />
                        </div>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                            <RHFInputBox
                                label={'Project:'}
                                name={'generateSummary.projectNumber'}
                                register={register}
                            />
                            <RHFInputBox
                                label={'Subcode:'}
                                name={'generateSummary.subCode'}
                                register={register}
                            />
                        </div>
                        {summaryOptions && <RHFSelect
                            labelStyle={{whiteSpace: 'nowrap'}}
                            labelOnLeft={true}
                            label={'Summary Type:'}
                            defaultVal={1}
                            options={Array.isArray(summaryOptions) && summaryOptions.length > 0 ?
                                summaryOptions?.map((so) => { return {value: so?.id, label: so?.summaryOption ? so?.summaryOption : ''}; }) : []} 
                            name={'generateSummary.summaryType'}
                            register={register}
                            style={{width: '100%'}}
                            bodyStyle={{width: '100%'}}
                            rules={{ required: 'Pay period required' }}
                        />}
                    </div>
                    <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                        <Button
                            className="blue-hover-button"
                            style={{ whiteSpace: 'nowrap', width: '58%', marginRight: '1rem' }}
                            text={'Generate Summary'}
                            type={'submit'}
                        />
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Cancel'}
                            onClick={() => props.hideDialog()}
                        />
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default GenerateExcelSummaryDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/GenerateExcelSummaryDialog.tsx